// `true` cuando el viewport es ≥768px (el breakpoint `md` de Tailwind).
//
// Existe aparte de `components/onboarding/useIsDesktop` porque ese usa `lg`
// (1024px) y los menús del composer bifurcan por `md:`. Con el hook de `lg`,
// entre 768 y 1023px el ESTILO sería desktop (flyout al costado) pero el
// COMPORTAMIENTO sería mobile (drill-down de dos páginas) — y el submenú no
// se vería. El breakpoint del hook tiene que ser el mismo que el del CSS.

import { useEffect, useState } from 'react';

const QUERY = '(min-width: 768px)';

export function useIsMdUp(): boolean {
  const [isMdUp, setIsMdUp] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
      return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsMdUp(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMdUp;
}

export default useIsMdUp;
